import type { Scale } from '../Scale';

import { SerialScale } from './SerialScale';

export const isSerialScale = (scale: Scale) : scale is SerialScale => {
  return scale instanceof SerialScale;
}
